import { render, staticRenderFns } from "./transactionTable.vue?vue&type=template&id=55bff84e&"
import script from "./transactionTable.vue?vue&type=script&lang=js&"
export * from "./transactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "transactionTable.vue"
export default component.exports